import { useEffect, useState } from 'react';
import { useAuth } from '@/app/AuthContext';

export function SettingsPage() {
  const { logout } = useAuth();

  // The bottom-tab-bar bug only manifests in an installed PWA, which has no
  // URL bar -- so the `?debug=viewport` readout was unreachable in the one
  // mode where it was needed. This toggle is the way in.
  const [debugOn, setDebugOn] = useState(() => {
    try {
      return window.localStorage.getItem('bn:debugViewport') === '1';
    } catch {
      return false;
    }
  });

  // The overlay's own Close button also clears the flag (so the user isn't
  // stuck hunting for this button underneath it). Without this listener,
  // this toggle would still read "Hide" after Close was used elsewhere,
  // costing the user an extra tap to re-sync it.
  useEffect(() => {
    const onChange = () => {
      try {
        setDebugOn(window.localStorage.getItem('bn:debugViewport') === '1');
      } catch {
        setDebugOn(false);
      }
    };
    window.addEventListener('bn:debugViewport-changed', onChange);
    return () => window.removeEventListener('bn:debugViewport-changed', onChange);
  }, []);

  const toggleDebug = () => {
    const next = !debugOn;
    try {
      window.localStorage.setItem('bn:debugViewport', next ? '1' : '0');
    } catch {
      /* private mode - the query string still works */
    }
    setDebugOn(next);
  };
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Settings</h1>
      </div>
      <div className="card">
        <h2>Layout diagnostic</h2>
        <p style={{ fontSize: 14, color: 'var(--color-ink-muted)', lineHeight: 1.6 }}>
          Shows a readout of what this device reports its own screen to be. Useful only if the bottom tabs sit
          above the home indicator — turn it on, screenshot it, then turn it off.
        </p>
        <button
          type="button"
          onClick={toggleDebug}
          className="action-btn"
          style={{ marginTop: 10, width: '100%' }}
        >
          {debugOn ? 'Hide viewport readout' : 'Show viewport readout'}
        </button>
      </div>

      <div className="card">
        <h2>About</h2>
        <p style={{ fontSize: 14, color: 'var(--color-ink-muted)' }}>
          Babcock Nav is a private app for our family. It is not indexed by search engines and is not accessible
          without the family PIN.
        </p>
      </div>
      <div className="card">
        <h2>Session</h2>
        <button type="button" className="btn btn-danger btn-block" onClick={() => logout()}>
          Log Out of This Device
        </button>
      </div>
    </div>
  );
}
